var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 40,
    viewBox: "0 0 97 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=RAG"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line",
    x1: 20.5,
    y1: 19.5,
    x2: 32.5,
    y2: 19.5,
    stroke: "#AED2FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Src"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 12,
    width: 24,
    height: 16,
    rx: 2,
    fill: "#AED2FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-genai",
    clipPath: "url(#clip0_23673_349180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5841 14.0804C52.6636 13.8734 52.8595 13.7373 53.0776 13.7373C53.2957 13.7373 53.4917 13.8734 53.5712 14.0804L55.4281 18.9064L60.1635 20.7987C60.3667 20.8799 60.5003 21.0795 60.5003 21.3018C60.5003 21.5241 60.3667 21.7238 60.1635 21.8049L55.4281 23.6972L53.5712 28.5232C53.4917 28.7302 53.2957 28.8663 53.0776 28.8663C52.8595 28.8663 52.6636 28.7302 52.5841 28.5232L50.7272 23.6972L45.9917 21.8049C45.7886 21.7238 45.655 21.5241 45.655 21.3018C45.655 21.0795 45.7886 20.8799 45.9917 20.7987L50.7272 18.9064L52.5841 14.0804Z",
    fill: "#265EDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3907 8.27103C42.4536 8.10749 42.6084 8 42.7807 8C42.953 8 43.1077 8.10749 43.1707 8.27103L44.6376 12.0837L48.3787 13.5786C48.5392 13.6428 48.6447 13.8004 48.6447 13.9761C48.6447 14.1516 48.5392 14.3094 48.3787 14.3735L44.6376 15.8685L43.1707 19.681C43.1077 19.8446 42.953 19.9522 42.7807 19.9522C42.6084 19.9522 42.4536 19.8446 42.3907 19.681L40.9238 15.8685L37.1827 14.3735C37.0223 14.3094 36.9167 14.1516 36.9167 13.9761C36.9167 13.8004 37.0223 13.6428 37.1827 13.5786L40.9238 12.0837L42.3907 8.27103Z",
    fill: "#265EDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5497 23.3585C40.5962 23.2375 40.7107 23.158 40.8382 23.158C40.9657 23.158 41.0802 23.2375 41.1267 23.3585L42.2119 26.179L44.9797 27.285C45.0983 27.3324 45.1765 27.4491 45.1765 27.579C45.1765 27.709 45.0983 27.8255 44.9797 27.873L42.2119 28.979L41.1267 31.7995C41.0802 31.9204 40.9657 32 40.8382 32C40.7107 32 40.5962 31.9204 40.5497 31.7995L39.4645 28.979L36.6968 27.873C36.5782 27.8255 36.5 27.709 36.5 27.579C36.5 27.4491 36.5782 27.3324 36.6968 27.285L39.4645 26.179L40.5497 23.3585Z",
    fill: "#265EDB"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Dest"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.5,
    y: 12,
    width: 24,
    height: 16,
    rx: 2,
    fill: "#AED2FF"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    x1: 64.5,
    y1: 19.5,
    x2: 76.5,
    y2: 19.5,
    stroke: "#AED2FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23673_349180"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(36.5 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRag);
export default __webpack_public_path__ + "static/media/rag.5385f042db319aac76ea4b0e394a71c9.svg";
export { ForwardRef as ReactComponent };